import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Site config
export const SITE = {
  brand: "Champagne & Sunshine",
  brandFull: "Champagne & Sunshine Real Estate Team",
  brandHouse: "The House of Excellence",
  tagline: "Celebrate every move.",
  positioning: "Local Experts · Skilled Negotiators · Trusted Advisors",
  agent: "Sunshine Rolland",
  agentGivenName: "Sonia Rolland",
  agentTitle: "Sunshine · Regional Sales Director",
  partner: "Champagne Mora",
  partnerTitle: "Champagne · Luxury Real Estate",
  partnerDre: "DRE 01271524",
  partnerPhone: "213.864.5474",
  partnerPhoneHref: "tel:+12138645474",
  brokerage: "KW L.A. Harbor · KW Luxury · KW Sports + Entertainment",
  phone: "805.637.2392",
  phoneHref: "tel:+18056372392",
  teamPhone: "310.429.5076",
  teamPhoneHref: "tel:+13104295076",
  email: "SoniaRolland@kw.com",
  emailHref: "mailto:SoniaRolland@kw.com",
  emailLegacy: "Sonia@spotlightrealtornetwork.com",
  partnerEmail: "Champagnemora@kw.com",
  partnerEmailHref: "mailto:Champagnemora@kw.com",
  teamEmail: "teamchampagneandsunshine@gmail.com",
  teamEmailHref: "mailto:teamchampagneandsunshine@gmail.com",
  escrowEmail: "sonia.rolland@westcoastescrow.com",
  escrowEmailHref: "mailto:sonia.rolland@westcoastescrow.com",
  dre: "DRE 02096015",
  serviceArea: "Greater Los Angeles, California",
  instagram: "https://www.instagram.com/spotlightsonia/",
  facebook: "https://www.facebook.com/sonia.a.rolland/",
  youtube: "https://www.youtube.com/@soniarollandLA",
};

// Curated images (from design guidelines)
export const IMG = {
  hero: "https://images.pexels.com/photos/2816168/pexels-photo-2816168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  // Team headshot used everywhere — solo Sunshine imagery has been replaced with the team photo
  agent:
    "https://customer-assets-v7afamib.emergentagent.net/job_la-property-pro/artifacts/ndvrk7k1_Untitled%20design%20-%202.jpeg",
  team:
    "https://customer-assets-v7afamib.emergentagent.net/job_la-property-pro/artifacts/ndvrk7k1_Untitled%20design%20-%202.jpeg",
  lifestyle1:
    "https://images.unsplash.com/photo-1665412019489-1928d5afa5cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxjYWxpZm9ybmlhJTIwYmVhY2glMjBsaWZlc3R5bGV8ZW58MHx8fHwxNzgwNTEwNjc5fDA&ixlib=rb-4.1.0&q=85",
  lifestyle2:
    "https://images.unsplash.com/photo-1580655653885-65763b2597d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MzJ8MHwxfHNlYXJjaHwyfHxsb3MlMjBhbmdlbGVzJTIwcGFsbSUyMHRyZWVzJTIwc3Vuc2V0fGVufDB8fHx8MTc4MDUxMDY2Nnww&ixlib=rb-4.1.0&q=85",
  interior1:
    "https://images.unsplash.com/photo-1779903726785-7cf25bed78f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjb2FzdGFsJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc4MDUxMDY2Nnww&ixlib=rb-4.1.0&q=85",
  interior2:
    "https://images.pexels.com/photos/276508/pexels-photo-276508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
